const ROUTES = {
  "/": {
    "name": "HomePageE951419844734786970e57e4d9d0f1c5",
    "type": "HTML",
    "key": "home-page"
  },
  "/_admin/*": {
    "name": "AdminPages59dd181f48144c368a35A849f2f8f89f",
    "type": "HTML",
    "key": "admin-pages"
  },
  "/about": {
    "name": "AboutUsPage6ad2bf4a2bb1443188b192725c364d23",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/about/leveling": {
    "name": "AboutLevelingPageCb3923a0602d43e3B2273ddee5ba8381",
    "type": "HTML",
    "key": "about-leveling-page"
  },
  "/about/offerings": {
    "name": "AboutOfferings3479e80c54e84c699f156976e741eea8",
    "type": "HTML",
    "key": "about-offerings"
  },
  "/about/susan": {
    "name": "AboutSusan4447c32fE61741d8A8bc55461b6fb689",
    "type": "HTML",
    "key": "about-susan"
  },
  "/events/public": {
    "name": "PublicEventsPage116ea88f02374ebc9201B97a136709e4",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPage6ced67578fac43609a1584268d702014",
    "type": "REFERENCE",
    "key": "join-us-page"
  },
  "/members-old/*": {
    "name": "MemberPagesOld429e88c15ea64e02900d7e69535861fb",
    "type": "HTML",
    "key": "member-pages-old"
  },
  "/members/messages-old/*": {
    "name": "MessagePagesOld1357ecd9A9f5446a813d18b00b585614",
    "type": "HTML",
    "key": "message-pages-old"
  },
  "/resources": {
    "name": "ResourcesPageAe3e5461B3d246f2Bc5b2a0a85c53e8c",
    "type": "REFERENCE",
    "key": "resources-page"
  },
  "/signup/*": {
    "name": "SignupPagesBce3bc00525c44e9936c3160ca9411f1",
    "type": "REFERENCE",
    "key": "signup-pages"
  }
};

export default ROUTES;